import React from "react";
import { RightPanel } from "../../../../../../components/RightPanel";
import { IBusinessPolicyFineArt } from "../../../../../../redux/businessPolicy/businessPolicyFineArt/businessPolicyFineArt.types";
import { FineArt } from "./FineArt";

interface IFineArtRightPanelProps {
  open: boolean;
  customerId?: number;
  customerPolicyId?: number;
  fineArtNumber?: number;
  onSaveSuccess: (fineArt: IBusinessPolicyFineArt) => void;
  staticStatusValue?: string;
  created_from?: string;
  readonly?: boolean;
  onClose: () => void;
  initialData?: IBusinessPolicyFineArt;
  disableApiCalls?: boolean;
}

export const FineArtRightPanel: React.FC<IFineArtRightPanelProps> = (
  props
) => {
  const {
	customerId,
	customerPolicyId,
	fineArtNumber,
	onClose,
	onSaveSuccess,
	readonly,
	staticStatusValue,
	created_from,
	initialData,
	disableApiCalls,
  } = props;

  return (
	<>
	  <RightPanel
		heading="Fine Art"
		//subHeading="Add notes or comments"
		open={true}
		onClose={onClose}
		width="80%"
	  >
		<FineArt
		  customerId={customerId}
		  customerPolicyId={customerPolicyId}
		  fineArtNumber={fineArtNumber}
		  onSaveSuccess={onSaveSuccess}
		  readOnly={readonly}
		  fromRightPanel
		  staticStatusValue={staticStatusValue}
		  created_from={created_from}
		  initialData={initialData}
		  disableApiCalls={disableApiCalls}
		/>
	  </RightPanel>
	</>
  );
};
